import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {
  AirbnbAuth,
  AirbnbVerificationMethod,
  AirbnbCodeVerification,
  AirbnbRedirectVerification
} from '../../../../models/airbnbAuthModel';
import AirbnbCodeVerificationProcedure from '../../../../containers/AirbnbCodeVerificationProcedure';
import AirbnbRedirectVerificationProcedure from '../../../../containers/AirbnbRedirectVerificationProcedure';

interface WithInjectedProps {
  airbnbAuth: AirbnbAuth;
}

@inject('airbnbAuth')
@observer
export default class AirbnbCredentialsVerification extends React.Component<{}, {}> {
  public render() {
    const {
      airbnbAuth: {verificationMethods}
    } = this._withInjectedProps;
    return verificationMethods.map((method, index) => this._renderVerificationMethod(method, index));
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private _renderVerificationMethod(method: AirbnbVerificationMethod, index: number) {
    if ((method as AirbnbCodeVerification).friction) {
      return <AirbnbCodeVerificationProcedure method={method as AirbnbCodeVerification} key={index} />;
    }

    if ((method as AirbnbRedirectVerification).linkRedirect) {
      return <AirbnbRedirectVerificationProcedure method={method as AirbnbRedirectVerification} key={index} />;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/pages/ConnectListings/ConnectAirbnb/AirbnbCredentialsVerification/AirbnbCredentialsVerification.tsx